import * as React from 'react'

import { TableProvider } from '../context/TableContext'
import ViolationsGrouped from '../tabs/violations_new/views/ViolationsGrouped'

export const DriverGroupViolationsPageNew = () => (
  <TableProvider bulk={true}>
    <ViolationsGrouped />
  </TableProvider>
)
